module.exports = __webpack_public_path__ + "media/didi.23ed8beb.wav";